import React, {useEffect, useRef} from "react";
import {useCsContext} from "../../state/CsInstance";

const TheaterApp: React.FC = () => {
	const csInstance = useCsContext();
	const canvasRef = useRef<HTMLCanvasElement>(null);

	// Only do this once
	useEffect(() => {
		const canvas = canvasRef.current;
		if (!canvas) {
			console.error("canvas not rendered when attempting to create TheaterApp");
			return;
		}
		// Gives control to the webworker
		const view: OffscreenCanvas = canvas.transferControlToOffscreen();
		csInstance.getOrCreateMessenger().initTheater({
			width: 800,
			height: 600,
			view,
		});

		// On unmount, release canvas to avoid piling up canvases
		return () => {
			csInstance.getOrCreateMessenger().destroyTheater();
		};
	}, [csInstance]);

	return <canvas className="csStage" ref={canvasRef} style={{width: "100%"}} />;
};

export default TheaterApp;
